App.document.ready(() => {
    if ($('.js-review-text').length > 0) {
        $('.js-review-text').each((ind, text) => {
            ReviewTextCrop(text);
        });

        App.W.on('resize', () => {
            $('.js-review-text').each((ind, text) => {
                ReviewTextCrop(text);
            });
        });

        // добавляем попап для отзывов
        App.B.append(
            `<div class="popup js-popup popup--review dinamic" data-name="review-popup">
                <div class="popup__container">
                    <div class="popup__close js-popup-close" tabindex="0">
                        <svg class="svg-icon" width="24" height="24">
                            <use xlink:href="/img/svg-symbols.svg#sym-close"></use>
                        </svg>
                    </div>
                    <div class="popup__content">
                        <div class="review-popup-top">
                            <div class="review-popup__name title-h4 js-review-popup-name"></div>
                            <div class="review-popup__company js-review-popup-company"></div>
                        </div>
                        <div class="review-popup-text">
                            <div class="review-popup-text-inner js-review-popup-text"></div>
                        </div>
                    </div>
                </div>
            </div>`
        );

        // делаем инит новых динамически добавляемых попапов
        App.W.trigger('popup:dinamic_init');
    }

    App.document.on('click', '.js-review-popup-open', function() {
        const $review = $(this);
        const $reviewText = $review.find('.js-review-text');
        const $reviewFull = $review.find('.js-review-full');
        const $reviewAuthor = $review.find('.js-review-name');
        const $reviewCompany = $review.find('.js-review-company');
        const $reviewPopup = App.H.find('.js-popup[data-name="review-popup"]');
        const reviewPopupText = $reviewFull.length && $.trim($reviewFull.text()).length > 0
            ? $reviewFull.html()
            : $reviewText.html();

        $reviewPopup.find('.js-review-popup-name').html($reviewAuthor.html());
        $reviewPopup.find('.js-review-popup-company').html($reviewCompany.html());
        $reviewPopup.find('.js-review-popup-text').html(reviewPopupText);
    });
});

function ReviewTextCrop(text) {
    const $review = $(text).closest('.js-review-popup-open');
    const $fullText = $review.find('.js-review-full');
    const hasFullText = $fullText.length && $.trim($fullText.text()).length > 0;

    if (hasFullText || $(text).innerHeight() >= 130) {
        $review
            .addClass('_haspopup')
            .data('popup', 'review-popup');
    } else {
        $review
            .removeClass('_haspopup')
            .removeAttr('data-popup');
    }
}
